'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = require('../grid');

exports["default"] = _grid.Col;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/col/index.tsx
 ** module id = 205
 ** module chunks = 0 1
 **/